import Vue from 'vue'

Vue.filter('date_to_human', function (value) {
	if(value){
		let date = new Date(value)
		let dateArray = date.toDateString().split(' ');
		return dateArray[2] + ' ' + dateArray[1] + ' ' + dateArray[3];
	}

})